import React from "react"
import {
  Select as ShadcnSelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { Label } from "@/components/ui/label"
import { cn } from "@/lib/utils"

export interface SelectProps {
  options?: Array<{ value: string | number; label: string }>
  label?: string
  helperText?: string
  error?: boolean
  value?: string
  onChange?: (value: string) => void
  disabled?: boolean
  placeholder?: string
  fullWidth?: boolean
  id?: string
  children?: React.ReactNode
}

export const Select: React.FC<SelectProps> = ({
  options = [],
  label,
  helperText,
  error,
  value,
  onChange,
  disabled,
  placeholder = "Select...",
  fullWidth = true,
  id,
  children,
}) => {
  const selectId = id || `select-${label?.toLowerCase().replace(/\s+/g, '-')}`

  return (
    <div className={cn("w-full space-y-2.5", !fullWidth && "w-auto")}>
      {label && (
        <Label htmlFor={selectId} className={cn("mb-1", error && "text-destructive")}>
          {label}
        </Label>
      )}
      <ShadcnSelect value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger
          id={selectId}
          className={cn(
            error && "border-destructive focus:border-destructive focus:ring-destructive/20",
            fullWidth && "w-full"
          )}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={String(option.value)} value={String(option.value)}>
              {option.label}
            </SelectItem>
          ))}
          {children}
        </SelectContent>
      </ShadcnSelect>
      {helperText && (
        <p className={cn("text-xs font-medium", error ? "text-destructive" : "text-muted-foreground")}>
          {helperText}
        </p>
      )}
    </div>
  )
}

export default Select
